import TeamRecordView from "./TeamRecordView";
const TeamRecordWrapper = () => {
  return <TeamRecordView />;
};

export default TeamRecordWrapper;
